const moveContainerStyles: React.CSSProperties = {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    bottom: "-10px",
    left: "-10px",
    zIndex: -1,
    cursor: "move",
};

export {moveContainerStyles};



// WEBPACK FOOTER //
// ./src/shared/ui/common/styles/index.ts